<template>
    <section class="inline large" v-if="!hideView">
        <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <div class="text-center">
                <p><b class="f7 text-uppercase" v-if="geo">{{geo.city}} Brokerage</b></p>
                <h2><b class="f3 text-bold">{{tabIndex == 0 ? 'Homes for Sale' : 'Past Transactions'}}</b></h2>
            </div>
            <div class="grid xs-grid-cols-1 sm-grid-cols-2 brokerage-nearby" v-if="filteredListings && filteredListings.length">
                <div class="brokerage-nearby-map" >
                    <mvtNewMap ref="map"
                        gestureHandling="cooperative"
                        @ready="onMapReady"
                        :disableMarkerPopups="true"
                        @markerSelected="onMarkerSelected"
                        :listings="filteredListings"></mvtNewMap>
                    <ul class="tab tab-pills" v-if="!agentId">
                        <li><a rel="nofollow" @click="onTabChange(1)" :class="{'active': tabIndex==1}">Sold</a></li>
                        <li><a rel="nofollow" @click="onTabChange(0)" :class="{'active': tabIndex==0}">Listed</a></li>
                    </ul>
                </div>
                <div class="brokerage-nearby-list" ref="list">
                    <div>
                        <template v-for="(house,i) in getListings">
                            <mvtCardProperty v-if="house && house.propertyId" :key="i" :data="house"></mvtCardProperty>
                        </template>
                    </div>
                </div>
            </div>
            <a v-if="glb.geo.cityPath" :href="glb.appUrl + glb.geo.cityPath" class="btn primary large center">Search {{glb.geo.city}} Homes</a>
        </div>
    </section>
</template>
<script src="./brokerage-nearby.js"></script>
<style lang="scss">
@use "./brokerage-nearby.scss" as *;
</style>